<template>
  <div class="container">
    <timebarchart v-if="loaded" :chartdata="chartdata" :options="options"/>
  <p style="font-size:12px" v-if="showDateRange"> <a href="#daterange" class="card-link">Click here to specify custom Date Range for chart</a><span v-if="(start_date != start_date_min) || (end_date != end_date_max)">. Custom Date Range in effect.  </span> </p>
  </div>
</template>

<script>
import TimeBarChart from "./TimeBarChart.js";
import { API } from "aws-amplify";

export default {
  name: "TimeBarChartNContainer",
  components: {
    timebarchart: TimeBarChart
  },
  props: ["collection_id", "collection_type", "user", "chart_id", "label", "stacked", "instance_num", "start_date", "end_date", "start_date_min", "end_date_max", "showDateRange"],
  data: () => ({
    loaded: false,
    chartdata: null,
    maindata: null,
    newdata: null,
    labels: null,
    options: {
      scales: {
        xAxes: [
          {
            stacked: true,  
            type: "time",
            // barPercentage: 0.04,
            // maxBarThickness: 16,
            time: {
              unit: 'day',
                    displayFormats: {
           'millisecond': 'MMM DD',
           'second': 'MMM DD',
           'minute': 'MMM DD',
           'hour': 'MMM DD',
           'day': 'MMM DD',
           'week': 'MMM DD',
           'month': 'MMM DD',
           'quarter': 'MMM DD',
           'year': 'MMM DD'
                    }
                }
          }
        ],
        yAxes: [
          {
            stacked: true
          }
        ]
      },
      responsive: true,
      maintainAspectRatio: false,
      gradient: null,
      gradient2: null

    }
  }),
  async mounted() {
    this.loaded = false;

// var ctx = document.getElementById('line-chart').getContext("2d")
//     this.gradient = ctx.createLinearGradient(0, 0, 0, 450)
//     this.gradient2 = ctx.createLinearGradient(0, 0, 0, 450)
    // this.gradient = this.$children[0].$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
    // this.gradient2 = this.$children[0].$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)

    // this.gradient.addColorStop(0, 'rgba(255, 0,0, 0.5)')
    // this.gradient.addColorStop(0.5, 'rgba(255, 0, 0, 0.25)');
    // this.gradient.addColorStop(1, 'rgba(255, 0, 0, 0)');
    
    // this.gradient2.addColorStop(0, 'rgba(0, 231, 255, 0.9)')
    // this.gradient2.addColorStop(0.5, 'rgba(0, 231, 255, 0.25)');
    // this.gradient2.addColorStop(1, 'rgba(0, 231, 255, 0)');
// console.log("stacked",this.stacked)
// console.log("chartid",this.chart_id)
    // this.options.scales.yAxes[0].stacked = this.stacked;

    try {
      // console.log("TBCC2: I am here");

      if (this.maindata == null) {
        var tries = 2;
        while (tries > 0) {
          var new_collection_id = this.collection_id;
          if (this.instance_num === undefined) {
          } else
          {
            new_collection_id = this.collection_id+'-'+this.instance_num;
          }
          await API.get("dbcsiAPI", `/dbcsi/${new_collection_id}/${this.collection_type}/${this.chart_id}`)
            .then(response => {
              // console.log("TBCC2: I am here3");
              // TOP_WAITS structure is [{metric,x,y}]
              
              this.maindata = response.data;
              // console.log('timebarchartncontainer:maindata',this.maindata.length);
              
              
              
              this.labels=[];
              
              for (var labeli = 0; labeli< 12; labeli++) {
                if (this.maindata[0]['metric'+labeli]) {
                  this.labels.push(this.maindata[0]['metric'+labeli]);
                }
              }  
              
              this.newdata = [];
              this.maindata.shift();
              
              if (this.start_date) {
                // console.log("start_date", this.start_date, this.maindata.length, this.maindata[0].x);
                this.maindata = this.maindata.filter((row) => row.x >= this.start_date);
                // console.log("start_date AFTER", this.start_date, this.maindata.length, this.maindata[0].x);
              }
              
              if (this.end_date) {
                // console.log("end_date", this.end_date, this.maindata.length, this.maindata[0].x);
                this.maindata = this.maindata.filter((row) => row.x <= (this.end_date+" 23:59:59") );
                // console.log("end_date AFTER", this.end_date, this.maindata.length, this.maindata[0].x);
              }
              

              for (var ii = 0; ii < this.maindata.length; ii++) {
                
                for (var labeli = 0; labeli < this.labels.length; labeli ++)
                {
                   if (ii==0) {
                     this.newdata.push([]);
                   } 
                  this.newdata[labeli].push({
                  x: this.maindata[ii].x,
                  y: this.maindata[ii]['y'+labeli]
                  });
                }
              } 
              // console.log(this.newdata[0]);
/*
              this.newdata = [];
              var newsubdata = [];
              var cur_metric="";
              for (var ii = 0; ii < this.maindata.length; ii++) {
                if (ii>0) {
                    //see if we have changed metrics
                    if (cur_metric != this.maindata[ii].metric) {
                        this.newdata.push(newsubdata);
                        newsubdata = [];
                        this.labels.push(cur_metric)
                        
                    }
                }  
                newsubdata.push({
                  x: this.maindata[ii].x,
                  y: this.maindata[ii].y
                })
                cur_metric = this.maindata[ii].metric

              }
              if (newsubdata != []) {
                  this.newdata.push(newsubdata);
                  this.labels.push(cur_metric)
              }
*/              
              tries = 0;
              // console.log('timebarchartncontainer:newdata',this.newdata.length);
              // console.log('timebarchartncontainer:newdata[0]',this.newdata[0].length);
              // console.log(this.newdata[0]);
            })
            .catch(error => {
              console.log("TCC2 Error:", error);
            });
          tries -= 1;
        }
      }

      // need to convert [{x,y1,y2},...] into [{x,y:y1}] and [{x,y:y2}].  Maybe support 2,3,4,...
      // need to update url to test/collection_id
      // need to make labels an array
      // need option to stack or not

        var borderColors=["rgba(0, 128, 0, 1)", 
        "#ff0000",
        "rgba(0, 0, 255, 1)", 
        "#FFA500",
        "rgba(194, 183, 155, 1)", 
        "rgba(0, 128, 128, 1)",
        "#FFFF00",
        "#800080", "rgba(128, 128, 0, 1)",  "#000000"];
        var backgroundColors=["rgba(0, 128, 0, 0.25)", 
        "rgba(255, 0,0, 0.25)",
        "rgba(0, 0, 255, 0.25)", 
        "rgba(255, 165, 0, 0.25)",
        "rgba(194, 183, 155, 0.25)", 
        "rgba(0, 128, 128, 0.25)",
        "rgba(255, 255, 0, 0.25)",
        "rgba(128, 0, 128, 0.25)", 
        "rgba(128, 128, 0, 0.25)",  
        "rgba(0, 0, 0, 0.25)"];

      this.chartdata = {
        datasets: [
          {
            label: this.labels[0],
            data: this.newdata[0],
            borderColor: borderColors[0],
            backgroundColor: backgroundColors[0],
            borderWidth: 1,
            pointRadius: 1,
            barThickness: 4,
            fill: true
          // borderColor: '#FC2525',
          // pointBackgroundColor: 'white',
          // borderWidth: 1,
          // pointBorderColor: 'white'
          // backgroundColor: this.gradient
          }]};

        for (var labeli = 1; labeli < this.labels.length; labeli++ ) {
          this.chartdata.datasets.push({
              label: this.labels[labeli],
              data: this.newdata[labeli],
              borderColor: borderColors[labeli],
              backgroundColor: backgroundColors[labeli],
              borderWidth: 1,
              pointRadius: 1,            
              barThickness: 4,
              fill: true
            });
        }    
          
 /*         {
            label: this.labels[1],
            data: this.newdata[1],
            // borderColor: "#3e95cd",
            borderColor: "rgba(0, 0, 255, 1)",
            backgroundColor: "rgba(0, 0, 255, 0.25)",
            // borderColor: "rgba(0, 231, 255, 1)",
            // backgroundColor: "rgba(0, 231, 255, 0.5)",
            borderWidth: 1,
            pointRadius: 1,   
            barThickness: 4,
            fill: true
          // borderColor: '#05CBE1',
          // pointBackgroundColor: 'white',
          // pointBorderColor: 'white'
          // borderWidth: 1
          // backgroundColor: this.gradient2

          },
          {
            label: this.labels[2],
            data: this.newdata[2],
            borderColor: "rgba(0, 255, 0, 1)",
            backgroundColor: "rgba(0, 255, 0, 0.25)",
            borderWidth: 1,
            pointRadius: 1,      
            barThickness: 4,
            fill: true
          },
          {
            label: this.labels[3],
            data: this.newdata[3],
            borderColor: "rgba(128, 128, 0, 1)",
            backgroundColor: "rgba(128, 128, 0, 0.25)",
            borderWidth: 1,
            pointRadius: 1,     
            barThickness: 4,
            fill: true
          },
          {
            label: this.labels[4],
            data: this.newdata[4],
            borderColor: "rgba(0, 128, 128, 1)",
            backgroundColor: "rgba(0, 128, 128, 0.25)",
            borderWidth: 1,
            pointRadius: 1,       
            barThickness: 4,
            fill: true
          },
          {
            label: this.labels[5],
            data: this.newdata[5],
            borderWidth: 1,
            pointRadius: 1,       
            barThickness: 4,
            fill: true
          },
          {
            label: this.labels[6],
            data: this.newdata[6],
            borderWidth: 1,
            pointRadius: 1,       
            barThickness: 4,
            fill: true
          },
          {
            label: this.labels[7],
            data: this.newdata[7],
            borderWidth: 1,
            pointRadius: 1,       
            barThickness: 4,
            fill: true
          },
          {
            label: this.labels[8],
            data: this.newdata[8],
            borderWidth: 1,
            pointRadius: 1,       
            barThickness: 4,
            fill: true
          },
          {
            label: this.labels[9],
            data: this.newdata[9],
            borderWidth: 1,
            pointRadius: 1,       
            barThickness: 4,
            fill: true
          }
          
          


        ]
      };*/
      
      this.loaded = true;
    } catch (e) {
      console.error(e);
    }
  }
};
</script>